import { render } from "./FormCard.vue?vue&type=template&id=746ba562&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"

import "./FormCard.vue?vue&type=style&index=0&id=746ba562&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746ba562"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
